import React from "react";
import { Container, Row, Col } from "reactstrap";
import "../styles/camry-package-item.css";
import img02 from "../assets/all-images/cars-img/bus.jpg";

const Bus = () => {
  return (
    <section>
      <Container>
        <Row>
          <Col lg="4" md="12" sm="12" className="mb-5" id="01">
            <div className="camry-package__item">
              <div className="camry-package__img--bus--bus">
                <img src={img02} alt="" className="w-100" />
              </div>

              <div className="camry-package__item-content mt-4">
                <h2 className="section__title text-center">Bus</h2>
                <h5 className="section__title text-center">
                  Jeddah Airport to Makkah Hotel
                </h5>
                <h6 className="rent__price text-center mt-">
                  SAR 600.00 <span></span>
                </h6>
                <button className=" w-50 camry-package__item-btn camry-package__btn-rent ">
                  <a href="tel:00966578189937">Call</a>
                </button>

                <button className=" w-50 camry-package__item-btn camry-package__btn-details">
                  <a
                    href="https://wa.me/+966578189937?text=Hello How can I help this route Jeddah Airport to Makkah Hotel using Bus?"
                    rel="ropener"
                  >
                    Whatsapp
                  </a>
                </button>
              </div>
            </div>
          </Col>
          <Col lg="4" md="12" sm="12" className="mb-5" id="08">
            <div className="camry-package__item">
              <div className="camry-package__img--bus">
                <img src={img02} alt="" className="w-100" />
              </div>

              <div className="camry-package__item-content mt-4">
                <h2 className="section__title text-center">Bus</h2>
                <h5 className="section__title text-center">
                  Madina Airport To Madina Hotel
                </h5>
                <h6 className="rent__price text-center mt-">
                  SAR 500.00 <span></span>
                </h6>
                <button className=" w-50 camry-package__item-btn camry-package__btn-rent">
                  <a href="tel:00966578189937">Call</a>
                </button>

                <button className=" w-50 camry-package__item-btn camry-package__btn-details">
                  <a
                    href="https://wa.me/+966578189937?text=Hello How can I help this route  Madina Airport To Madina Hotel using Bus?"
                    rel="ropener"
                  >
                    Whatsapp
                  </a>
                </button>
              </div>
            </div>
          </Col>
          <Col lg="4" md="12" sm="12" className="mb-5" id="03">
            <div className="camry-package__item">
              <div className="camry-package__img--bus">
                <img src={img02} alt="" className="w-100" />
              </div>

              <div className="camry-package__item-content mt-4">
                <h2 className="section__title text-center">Bus</h2>
                <h5 className="section__title text-center">
                  Makkah Hotel to Madina Hotel
                </h5>
                <h6 className="rent__price text-center mt-">
                  SAR 1300.00 <span></span>
                </h6>
                <button className=" w-50 camry-package__item-btn camry-package__btn-rent">
                  <a href="tel:00966578189937">Call</a>
                </button>

                <button className=" w-50 camry-package__item-btn camry-package__btn-details">
                  <a
                    href="https://wa.me/+966578189937?text=Hello How can I help this route  Makkah Hotel to Madina Hotel? using Bus"
                    rel="ropener"
                  >
                    Whatsapp
                  </a>
                </button>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg="4" md="12" sm="12" className="mb-5" id="02">
            <div className="camry-package__item">
              <div className="camry-package__img--bus">
                <img src={img02} alt="" className="w-100" />
              </div>

              <div className="camry-package__item-content mt-4">
                <h2 className="section__title text-center">Bus</h2>
                <h5 className="section__title text-center">
                  Jeddah Airport To Madina Hotel
                </h5>
                <h6 className="rent__price text-center mt-">
                  SAR 1350.00 <span></span>
                </h6>
                <button className=" w-50 camry-package__item-btn camry-package__btn-rent">
                  <a href="tel:00966578189937">Call</a>
                </button>

                <button className=" w-50 camry-package__item-btn camry-package__btn-details">
                  <a
                    href="https://wa.me/+966578189937?text=Hello How can I help this route  Jeddah Airport To Madina Hotel using Bus?"
                    using
                    Camry
                    Car
                    rel="ropener"
                  >
                    Whatsapp
                  </a>
                </button>
              </div>
            </div>
          </Col>
          <Col lg="4" md="12" sm="12" className="mb-5" id="09">
            <div className="camry-package__item">
              <div className="camry-package__img--bus">
                <img src={img02} alt="" className="w-100" />
              </div>

              <div className="camry-package__item-content mt-4">
                <h2 className="section__title text-center">Bus</h2>
                <h5 className="section__title text-center">Makkah Ziyarat</h5>
                <h6 className="rent__price text-center mt-">
                  SAR 500.00 <span></span>
                </h6>
                <button className=" w-50 camry-package__item-btn camry-package__btn-rent">
                  <a href="tel:00966578189937">Call</a>
                </button>

                <button className=" w-50 camry-package__item-btn camry-package__btn-details">
                  <a
                    href="https://wa.me/+966578189937?text=Hello How can I help this route  Makkah Ziyarat using Bus?"
                    rel="ropener"
                  >
                    Whatsapp
                  </a>
                </button>
              </div>
            </div>
          </Col>
          <Col lg="4" md="12" sm="12" className="mb-5" id="05">
            <div className="camry-package__item">
              <div className="camry-package__img--bus">
                <img src={img02} alt="" className="w-100" />
              </div>

              <div className="camry-package__item-content mt-4">
                <h2 className="section__title text-center">Bus</h2>
                <h5 className="section__title text-center">Madina Ziyarat</h5>
                <h6 className="rent__price text-center mt-">
                  SAR 400.00 <span></span>
                </h6>
                <button className=" w-50 camry-package__item-btn camry-package__btn-rent">
                  <a href="tel:00966578189937">Call</a>
                </button>

                <button className=" w-50 camry-package__item-btn camry-package__btn-details">
                  <a
                    href="https://wa.me/+966578189937?text=Hello How can I help this route  Madina Ziyarat using Bus?"
                    rel="ropener"
                  >
                    Whatsapp
                  </a>
                </button>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg="4" md="12" sm="12" className="mb-5" id="06">
            <div className="camry-package__item">
              <div className="camry-package__img--bus">
                <img src={img02} alt="" className="w-100" />
              </div>

              <div className="camry-package__item-content mt-4">
                <h2 className="section__title text-center">Bus</h2>
                <h5 className="section__title text-center">
                  Makkah To Taif Ziyarat And Return
                </h5>
                <h6 className="rent__price text-center mt-">
                  SAR 950.00 <span></span>
                </h6>
                <button className=" w-50 camry-package__item-btn camry-package__btn-rent">
                  <a href="tel:00966578189937">Call</a>
                </button>

                <button className=" w-50 camry-package__item-btn camry-package__btn-details">
                  <a
                    href="https://wa.me/+966578189937?text=Hello How can I help this route Makkah To Taif Ziyarat And Return using Bus?"
                    using
                    Camry
                    Car
                    rel="ropener"
                  >
                    Whatsapp
                  </a>
                </button>
              </div>
            </div>
          </Col>
          <Col lg="4" md="12" sm="12" className="mb-5" id="07">
            <div className="camry-package__item">
              <div className="camry-package__img--bus">
                <img src={img02} alt="" className="w-100" />
              </div>

              <div className="camry-package__item-content mt-4">
                <h2 className="section__title text-center">Bus</h2>
                <h5 className="section__title text-center">
                  Makkah Hotel To Jeddah Airport
                </h5>
                <h6 className="rent__price text-center mt-">
                  SAR 550.00 <span></span>
                </h6>
                <button className=" w-50 camry-package__item-btn camry-package__btn-rent">
                  <a href="tel:00966578189937">Call</a>
                </button>

                <button className=" w-50 camry-package__item-btn camry-package__btn-details">
                  <a
                    href="https://wa.me/+966578189937?text=Hello How can I help this route Makkah Hotel To Jeddah Airport using Bus?"
                    using
                    Camry
                    Car
                    rel="ropener"
                  >
                    Whatsapp
                  </a>
                </button>
              </div>
            </div>
          </Col>
          <Col lg="4" md="12" sm="12" className="mb-5" id="10">
            <div className="camry-package__item">
              <div className="camry-package__img--bus">
                <img src={img02} alt="" className="w-100" />
              </div>

              <div className="camry-package__item-content mt-4">
                <h2 className="section__title text-center">Bus</h2>
                <h5 className="section__title text-center">
                  Madina Hotel To Madina Airport
                </h5>
                <h6 className="rent__price text-center mt-">
                  SAR 450.00 <span></span>
                </h6>
                <button className=" w-50 camry-package__item-btn camry-package__btn-rent">
                  <a href="tel:00966578189937">Call</a>
                </button>

                <button className=" w-50 camry-package__item-btn camry-package__btn-details">
                  <a
                    href="https://wa.me/+966578189937?text=Hello How can I help this route   Madina Hotel To Madina Airport using Bus?"
                    using
                    Camry
                    Car
                    rel="ropener"
                  >
                    Whatsapp
                  </a>
                </button>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg="4" md="12" sm="12" className="mb-5" id="04">
            <div className="camry-package__item">
              <div className="camry-package__img--bus">
                <img src={img02} alt="" className="w-100" />
              </div>

              <div className="camry-package__item-content mt-4">
                <h2 className="section__title text-center">Bus</h2>
                <h5 className="section__title text-center">
                  Madina Hotel To Makkah Hotel
                </h5>
                <h6 className="rent__price text-center mt-">
                  SAR 1350.00 <span></span>
                </h6>
                <button className=" w-50 camry-package__item-btn camry-package__btn-rent">
                  <a href="tel:00966578189937">Call</a>
                </button>

                <button className=" w-50 camry-package__item-btn camry-package__btn-details">
                  <a
                    href="https://wa.me/+966578189937?text=Hello How can I help this route  Madina Hotel To Makkah Hotel using Bus?"
                    using
                    Camry
                    Car
                    rel="ropener"
                  >
                    Whatsapp
                  </a>
                </button>
              </div>
            </div>
          </Col>

          <Col lg="4" md="12" sm="12" className="mb-5" id="11">
            <div className="camry-package__item">
              <div className="camry-package__img--bus">
                <img src={img02} alt="" className="w-100" />
              </div>

              <div className="camry-package__item-content mt-4">
                <h2 className="section__title text-center">Bus</h2>
                <h5 className="section__title text-center">
                  Madina Hotel To Jeddah Airport
                </h5>
                <h6 className="rent__price text-center mt-">
                  SAR 1350.00 <span></span>
                </h6>
                <button className=" w-50 camry-package__item-btn camry-package__btn-rent">
                  <a href="tel:00966578189937">Call</a>
                </button>

                <button className=" w-50 camry-package__item-btn camry-package__btn-details">
                  <a
                    href="https://wa.me/+966578189937?text=Hello How can I help this route Madina Hotel To Jeddah Airport using Bus?"
                    rel="ropener"
                  >
                    Whatsapp
                  </a>
                </button>
              </div>
            </div>
          </Col>

          <Col lg="4" md="12" sm="12" className="mb-5" id="12">
            <div className="camry-package__item">
              <div className="camry-package__img--bus">
                <img src={img02} alt="" className="w-100" />
              </div>

              <div className="camry-package__item-content mt-4">
                <h2 className="section__title text-center">Bus</h2>
                <h5 className="section__title text-center">
                  Jeddah To Taif Ziyarat And Return
                </h5>
                <h6 className="rent__price text-center mt-">
                  SAR 1500.00 <span></span>
                </h6>
                <button className=" w-50 camry-package__item-btn camry-package__btn-rent">
                  <a href="tel:00966578189937">Call</a>
                </button>

                <button className=" w-50 camry-package__item-btn camry-package__btn-details">
                  <a
                    href="https://wa.me/+966578189937?text=Hello How can I help this route Jeddah To Taif Ziyarat And Return Hotel using Bus?"
                    rel="ropener"
                  >
                    Whatsapp
                  </a>
                </button>
              </div>
            </div>
          </Col>
          <Col lg="4" md="12" sm="12" className="mb-5" id="13">
            <div className="camry-package__item">
              <div className="camry-package__img--bus">
                <img src={img02} alt="" className="w-100" />
              </div>

              <div className="camry-package__item-content mt-4">
                <h2 className="section__title text-center">Bus</h2>
                <h5 className="section__title text-center">
                  Jeddah Airport to Jeddah Hotel
                </h5>
                <h6 className="rent__price text-center mt-">
                  SAR 300.00 <span></span>
                </h6>
                <button className=" w-50 camry-package__item-btn camry-package__btn-rent">
                  <a href="tel:00966578189937">Call</a>
                </button>

                <button className=" w-50 camry-package__item-btn camry-package__btn-details">
                  <a
                    href="https://wa.me/+966578189937?text=Hello How can I help this route Jeddah Airport to Jeddah Hotel using Bus?"
                    rel="ropener"
                  >
                    Whatsapp
                  </a>
                </button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Bus;
